<template>
  <v-container fluid class="asignaciones-view ui-module-fade-in-up">
    <v-card class="ui-module-card ui-module-fade-in-up asignaciones-shell" flat>
      <v-card-text class="asignaciones-content">
        <v-row class="toolbar-row" justify="end" align="center">
          <v-col cols="auto" class="d-flex align-center justify-end toolbar-search-col">
            <v-text-field
              class="search-input"
              v-model="search"
              color="secondary"
              background-color="primary"
              rounded
              filled
              hide-details
              placeholder="Buscar asignación..."
              append-icon="mdi-magnify"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="asignacionesTabla"
              :search="search"
              class="card ui-module-card ui-module-table asignaciones-table"
              color="primary"
              :loading="loading"
              loading-text="Cargando asignaciones..."
              :no-data-text="subsede ? 'No hay asignaciones registradas.' : 'Tu usuario no tiene una subsede asignada.'"
              no-results-text="No se encontraron asignaciones con esa búsqueda."
              :footer-props="{ 'items-per-page-text': 'Filas por página' }"
            >
              <template #[`item.fechaSolicitud`]="{ item }">
                {{ formatearFecha(item.fechaSolicitud) }}
              </template>
              <template #[`item.fechaAsignacion`]="{ item }">
                {{ formatearFecha(item.fechaAsignacion) }}
              </template>
              <template #[`item.cantidadEquipos`]="{ item }">
                {{ (item.equipoAsignado || []).length }}
              </template>
              <template #[`item.actions`]="{ item }">
                <v-btn icon color="secondary" class="ui-module-icon-action" @click="openDetalleDialog(item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <detalle-asignacion-equipo-subsede-dialog-component
      :active="detalleDialog"
      :asignacion="selectedAsignacion"
      @close="closeDetalleDialog()"
    ></detalle-asignacion-equipo-subsede-dialog-component>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DetalleAsignacionEquipoSubsedeDialogComponent from '@/components/equipamiento/DetalleAsignacionEquipoSubsedeDialogComponent.vue'

export default {
  components: {
    DetalleAsignacionEquipoSubsedeDialogComponent,
  },

  async mounted() {
    this.loading = true
    const { idSubsede } = await this.fetchSedePersonal(this.idPersonal)
    if (idSubsede) {
      await this.fetchAsignacionesBySubsede(idSubsede)
    }
    this.loading = false
  },

  data() {
    return {
      search: '',
      loading: false,
      detalleDialog: false,
      selectedAsignacion: null,

      headers: [
        { text: 'Fecha de solicitud', value: 'fechaSolicitud', sortable: true },
        { text: 'Fecha de asignación', value: 'fechaAsignacion', sortable: true },
        { text: 'Folio de resguardo', value: 'folioResguardo', sortable: true },
        { text: 'Equipos', value: 'cantidadEquipos', sortable: false },
        { text: 'Detalle', value: 'actions', sortable: false, align: 'center' },
      ],
    }
  },

  computed: {
    ...mapGetters({ idPersonal: 'getIdPersonal' }),
    ...mapGetters('subsedeAsignacion', { subsede: 'getSubsedeUsuario' }),

    asignacionesTabla() {
      if (!this.subsede) return []

      return (this.subsede.asignaciones || [])
        .filter((asignacion) => (asignacion.equipoAsignado || []).length > 0)
        .map((asignacion) => ({
          ...asignacion,
          idSubSede: this.subsede.idSubSede,
          subSede: this.subsede.subSede,
          nombreSede: this.subsede.nombreSede,
        }))
    },
  },

  methods: {
    ...mapActions('personal', ['fetchSedePersonal']),
    ...mapActions('subsedeAsignacion', ['fetchAsignacionesBySubsede']),

    formatearFecha(valor) {
      if (!valor) return '—'
      const d = new Date(valor)
      return d.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },

    openDetalleDialog(asignacion) {
      this.selectedAsignacion = asignacion
      this.detalleDialog = true
    },

    closeDetalleDialog() {
      this.detalleDialog = false
      this.selectedAsignacion = null
    },
  },
}
</script>

<style scoped>
.asignaciones-shell {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

.asignaciones-content {
  padding: 20px !important;
}

.toolbar-row {
  margin-bottom: 4px;
}

.toolbar-search-col {
  width: 360px;
  max-width: 360px;
  flex: 0 0 360px;
}

::v-deep .toolbar-search-col .v-input {
  width: 100%;
  margin-top: 0 !important;
}

::v-deep .search-input .v-input__slot {
  background: rgba(8, 14, 19, 0.52) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.2) !important;
  border-radius: 14px !important;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2) !important;
}

::v-deep .search-input .v-label,
::v-deep .search-input input,
::v-deep .search-input .v-icon {
  color: #e0f0ff !important;
}

::v-deep .search-input.v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 69, 170, 242), 0.16) !important;
}

@media (max-width: 960px) {
  .toolbar-search-col {
    width: 100%;
    max-width: 100%;
    flex: 1 1 100%;
  }
}
</style>
